import { ChangeEvent, FC, useCallback, useMemo } from 'react';
import S from './SwitchButton.module.scss';
import { Text } from 'src/redesign/components/Text';

type SwitchButtonProps = {
  items: [string, string];
  onChange: (item: string) => void;
  className?: string;
  value?: string;
  id?: string;
};

let switchButtonIdCounter = 0;

export const SwitchButton: FC<SwitchButtonProps> = (props) => {
  // Generate a unique ID for this instance
  const uniqueId = useMemo(
    () => props.id || `switch-button-${++switchButtonIdCounter}`,
    [props.id],
  );

  const handleOnClick = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        props.onChange(props.items[1]);
        return;
      }
      props.onChange(props.items[0]);
    },
    [props],
  );

  // Determine if checkbox should be checked based on value prop
  const isChecked = props.value === props.items[1];

  return (
    <div>
      <input
        onChange={handleOnClick}
        type="checkbox"
        id={uniqueId}
        className={S.toggleCheckbox}
        checked={isChecked}
      />
      <label htmlFor={uniqueId} className={S.toggleContainer}>
        {props.items.map((item) => (
          <Text key={item} variation="body">
            {item}
          </Text>
        ))}
      </label>
    </div>
  );
};
